import LazyLoad from 'vanilla-lazyload';

export default class LazyLoadImage {
	constructor () {
		this.initEvents();
	}

    initEvents () {
        this.lazyLoading();
	}

    /**
    * LazyLoad image
    * https://github.com/verlok/vanilla-lazyload
    */
    lazyLoading(elementSelector = '.lazy-load') {
        let lazyLoading = new LazyLoad({
            elements_selector: elementSelector,
            load_delay: 300
        });

        lazyLoading.update();
    }
}
